"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Text = ({
  paragraph,
  intro,
  small,
  extrasmall,
  bold,
  semibold,
  subtle,
  color,
  size,
  title,
  onClick,
  children,
  primary,
  secondary,
  dark,
  italic,
  align,
  wordBreak,
  whiteSpace,
  lineClamp,
  ...restProps
}) => {
  const Tag = paragraph ? 'p' : 'span';
  return (0, _jsxRuntime.jsx)(Tag, {
    css: theme => [_styles.styles.default(theme, color), intro && _styles.styles.intro, small && _styles.styles.small, extrasmall && _styles.styles.extrasmall, bold && _styles.styles.bold, semibold && _styles.styles.semiBold, subtle && _styles.styles.subtle(theme), paragraph && _styles.styles.paragraph, size && _styles.styles.size(size), primary && _styles.styles.setColor(theme.primary), secondary && _styles.styles.setColor(theme.secondary), italic && _styles.styles.italic, align && _styles.styles.align(align), dark && _styles.styles.setColor(theme.secondaryDarkText), wordBreak && _styles.styles.setWordBreak(wordBreak), whiteSpace && _styles.styles.setWhiteSpace(whiteSpace), lineClamp && _styles.styles.setLineClamp(lineClamp)],
    onClick: onClick,
    title: title,
    ...restProps,
    children: children
  });
};
var _default = exports.default = Text;